import React, { FC } from 'react';
import { useModal } from 'store/modal';
import API from 'core/Api';
import Button from 'components/Button';
import TooltipWrapper from 'components/TooltipWrapper';
import { useTranslation } from 'react-i18next';
import { IoSendSharp } from 'react-icons/io5';
import { createErrorFromResponse } from 'core/Error';
import useInvalidateQueries from 'utils/helpers/useInvalidateQueries';

interface IProps {
  children?: any;
  type: 'send-to-employee' | 'send-to-employer';
  id: string;
  buttonText: string;
  disabled: boolean;
  invalidate: () => void;
}

const SendDoc: FC<IProps> = ({ type, id, buttonText, disabled, invalidate }: IProps) => {
  const { t } = useTranslation();
  const { showModal } = useModal();
  const invalidateQueries = useInvalidateQueries();

  // Send document
  const handleSend = (docId: string) =>
    API.post(`document-holders/${docId}/${type}`)
      .then(() => {
        showModal({
          type: 'success',
          content: t('documents.table.sentDocSuccessMsg'),
        });
        invalidateQueries([], invalidate);
      })
      .catch(err =>
        showModal({
          type: 'error',
          content: createErrorFromResponse(err).message,
        })
      );

  // Confirm send
  const confirmSend = (docId: string) => {
    showModal({
      type: 'confirm',
      heading: t('documents.table.confirmSendDocHeading'),
      content: t('documents.table.confirmSendDocMsg'),
      onConfirm: () => handleSend(docId),
      confirmLabel: t('documents.table.confirmSendDocLabel'),
    });
  };

  return (
    <TooltipWrapper
      id="tooltip-send"
      overlay={buttonText}
    >
      <Button
        type="button"
        btnType="icon"
        disabled={disabled}
        onClick={e => {
          confirmSend(id);
          e.stopPropagation();
        }}
      >
        <IoSendSharp
          size={18}
          color="#32bfa3"
        />
      </Button>
    </TooltipWrapper>
  );
};

export default SendDoc;
